import { render } from "./LoreNav.vue?vue&type=template&id=64cb8738&scoped=true&bindings={\"lastScrollY\":\"data\",\"isHidden\":\"data\",\"isShown\":\"data\",\"hideTimeout\":\"data\",\"navbarOffset\":\"data\",\"currentSection\":\"data\",\"sections\":\"data\",\"observer\":\"data\",\"scrollTo\":\"options\",\"handleScroll\":\"options\",\"setupObserver\":\"options\"}"
import script from "./LoreNav.vue?vue&type=script&lang=js"
export * from "./LoreNav.vue?vue&type=script&lang=js"

import "./LoreNav.vue?vue&type=style&index=0&id=64cb8738&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64cb8738"

export default script